module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[90]455.35a7552.woff2";